// extracted by mini-css-extract-plugin
export default {"wrapper":"Option_wrapper__BiImG","icon":"Option_icon__5NbP5"};